import {Component, OnInit} from '@angular/core';
import {AppComponent} from '../app.component';
import {URL_API} from './../constante';

declare var jQuery: any;

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.css']
})
export class ConfigComponent extends AppComponent implements OnInit {

    service = this.configService;
	url: string = URL_API;

    ngOnInit() {
		if (!this.isAdmin())
			this.router.navigateByUrl('inicio');
		else 
			this.validar_login();
    }
	
	apagarLogs(): void {
		this.service.apagarLogs().then(resp => (resp));
	}
}



// WEBPACK FOOTER //
// ./src/app/config/config.component.ts